// extracted by mini-css-extract-plugin
export var danger = "_44-6";
export var lightPink = "_44-a";
export var medium = "_44-j";
export var nearSquare = "_44-m";
export var neutralBlue = "_44-8";
export var neutralYellow = "_44-7";
export var noCapitalize = "_44-1";
export var normal = "_44-2";
export var pill = "_44-0";
export var primary = "_44-3";
export var primaryLight = "_44-4";
export var shadow = "_44-n";
export var small = "_44-k";
export var solidBlack = "_44-i";
export var solidGreen = "_44-d";
export var solidLightBlue = "_44-f";
export var solidNavy = "_44-e";
export var solidOrange = "_44-h";
export var solidPink = "_44-g";
export var solidRed = "_44-b";
export var solidWhite = "_44-9";
export var solidYellow = "_44-c";
export var success = "_44-5";
export var xsmall = "_44-l";